import Ajv from 'ajv';

import { setIsLoading, setSuccess, setError } from './email-quote-slice';
import { sendQuoteByEmail } from 'api/send-quote-by-email';
import { getErrors } from 'api/client';
import { SchemaValidationError } from 'errors/SchemaValidationError';
import { actionUrl } from 'config/static-content';

import emailQutePayloadSchema from 'api/schemas/email-quote-payload-schema.json';

export const sendQuoteThunk = (payload) => async (dispatch) => {
  const ajv = new Ajv({ strict: false });
  const isValidPayload = ajv.validate(emailQutePayloadSchema, payload);

  if (!isValidPayload) {
    const error = new SchemaValidationError({
      message: `We cannot email your quote at this time. Please contact ${actionUrl.support}`,
      payload,
      schema: emailQutePayloadSchema,
      ajvErrors: ajv.errors
    });
    const errors = [error.toJson()];

    dispatch(setError(errors));
    throw error;
  }

  try {
    dispatch(setIsLoading());
    const response = await sendQuoteByEmail(payload);
    dispatch(setSuccess(response));

    return Promise.resolve(response);
  } catch (e) {
    const errors = getErrors(e);
    errors && dispatch(setError(errors));

    return Promise.reject(errors);
  }
};
